import { LocalizedTextModel } from "src/app/admin/product-services/shared/models/LocalizedTextModel";
import { Language } from "src/app/master/models/language";

export class ChecklistResponseModel {
    sortValue: number = 0;
    checklistItem: string = '';
    linkName: string = '';
    link: string = '';
    checklistId: number = 0;
    isEditing: boolean = false;
    language?: Language;
    localizedChecklistItem: LocalizedTextModel[] = [];
    localizedLinkName: LocalizedTextModel[] = [];
    localizedRowId?: string;
    _prevLanguageId: number = 1;
}
